// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.radiobox-module__radiobox___chFqx {
  cursor: pointer;
  position: relative;
}
.radiobox-module__radiobox___chFqx input[type=radio] {
  width: 0;
  height: 0;
  position: absolute;
  opacity: 0;
}
.radiobox-module__radiobox___chFqx input[type=radio] + label {
  position: relative;
  padding-left: 27px;
  display: inline-block;
  width: 100%;
}
.radiobox-module__radiobox___chFqx input[type=radio] + label:before {
  content: "";
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid var(--neutral75, #424547);
  position: absolute;
  left: 0;
}
.radiobox-module__radiobox___chFqx input[type=radio]:checked + label:before {
  border: 5px solid var(--primary600, #4b286d);
  transition: border 0.3s cubic-bezier(0.18, 0.89, 0.68, 1.93);
}
.radiobox-module__radiobox___chFqx input[type=radio]:focus + label:before {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}

.radiobox-module__title___WuGAo {
  vertical-align: middle;
  font-size: 0.875rem;
  height: 20px;
  color: var(--neutral100, #2c2e30);
}

.radiobox-module__subtitle___QLDIw {
  display: inline-block;
  vertical-align: middle;
  max-width: calc(100% - 32px);
  font-size: 0.875rem;
  color: var(--neutral75, #424547);
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/inputs/radiobox-comp/radiobox.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,eAAA;EACA,kBAAA;AAMF;AAJE;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAMJ;AAJI;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AAMN;AAJM;EACE,WAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,OAAA;AAMR;AADM;EACE,4CAAA;EACA,4DAAA;AAGR;AAEM;EClCF,wCAAA;EACA,mBAAA;ADmCJ;;AAKA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;AAFF;;AAKA;EACE,qBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gCAAA;AAFF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils.scss';\n\n.radiobox {\n  cursor: pointer;\n  position: relative;\n\n  input[type='radio'] {\n    width: 0;\n    height: 0;\n    position: absolute;\n    opacity: 0;\n\n    + label {\n      position: relative;\n      padding-left: 27px;\n      display: inline-block;\n      width: 100%;\n\n      &:before {\n        content: '';\n        box-sizing: border-box;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        border: 1px solid color(neutral75);\n        position: absolute;\n        left: 0;\n      }\n    }\n\n    &:checked {\n      + label:before {\n        border: 5px solid color(primary600);\n        transition: border 0.3s cubic-bezier(0.18, 0.89, 0.68, 1.93);\n      }\n    }\n\n    &:focus {\n      + label:before {\n        @include focus-outline($applyDirectly: true);\n      }\n    }\n  }\n}\n\n.title {\n  vertical-align: middle;\n  font-size: rem(14);\n  height: 20px;\n  color: color(neutral100);\n}\n\n.subtitle {\n  display: inline-block;\n  vertical-align: middle;\n  max-width: calc(100% - 32px);\n  font-size: rem(14);\n  color: color(neutral75);\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radiobox": `radiobox-module__radiobox___chFqx`,
	"title": `radiobox-module__title___WuGAo`,
	"subtitle": `radiobox-module__subtitle___QLDIw`
};
export default ___CSS_LOADER_EXPORT___;
